import { render, staticRenderFns } from "./AssetsList.vue?vue&type=template&id=041faf4c&"
import script from "./AssetsList.vue?vue&type=script&lang=js&"
export * from "./AssetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports